// src/components/Hero.jsx
import React, { useEffect } from "react";
import Lottie from "lottie-react";
import animationData from "../assets/first-right-laptop-main-logo.json";
import { motion } from "framer-motion";
import { TypeAnimation } from "react-type-animation";


const Hero = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);



    return (
        <div className="relative bg-black text-white py-10 overflow-hidden">
            {/* Particle Background */}

            {/* Main Content */}
            <div className="relative xl:xyz1 md:xyz1 lg:xyz1 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-4">
                {/* Left Content */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                    className="w-full md:w-7/12 text-center md:text-left"
                >
                    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight space-y-3">
                        <div>
                            <span className="text-[#aab863]">Modern</span>{" "}
                            <span className="text-white">Tech</span>{" "}
                            <span className="text-[#aab863]">&</span>{" "}
                            <span className="text-white">IT.</span>
                        </div>
                        <div>
                            <span className="text-white">Trusted</span>{" "}
                            <span className="text-[#c96c4e]">Services</span>
                        </div>

                        <TypeAnimation
                            className="text-[#cbdfbd] block"
                            sequence={["Web", 2000, "Google", 2000, "Facebook", 2000, "Insta", 2000, "PPC", 2000, "Shopify", 2000]}
                            wrapper="span"
                            speed={50}
                            repeat={Infinity}
                            cursor={false}
                        />
                        <TypeAnimation
                            className="text-[#e8c547] block"
                            sequence={["Dev", 2000, "SEO", 2000, "Ads", 2000, "Services", 2000, "Store", 2000]}
                            wrapper="span"
                            speed={50}
                            repeat={Infinity}
                            cursor={false}
                        />
                    </h1>
                </motion.div>

                {/* Lottie Animation */}
                <div className="w-full xl:xyz1 md:xyz1 lg:xyz1 md:w-5/12 flex justify-center md:justify-end mt-10 md:mt-0">
                    <Lottie
                        animationData={animationData}
                        loop
                        autoplay
                        className="w-[300px] sm:w-[400px] md:w-[450px] lg:w-[500px]"
                    />
                </div>
            </div>
        </div>

    );
};

export default Hero;
